import { ReducersTypes } from '../../../Constants/ReducersTypes';

export const setOnbConfig = (data) => ({
  type: ReducersTypes.SET_ONB_CONFIG_STATUS,
  payload: data,
});

export const setCurrentStep = (data) => ({
  type: ReducersTypes.SET_CURRENT_ONBOARDING_STEP,
  payload: data,
});

export const setOnboardingModalFlag = (data) => ({
  type: ReducersTypes.SHOW_ONBOARDING,
  payload: data,
});

export const setOnboardingData = (data) => ({
  type: ReducersTypes.SET_ONBOARDING_DATA,
  payload: data,
});

export const resetUsers = () => ({
  type: ReducersTypes.RESET_ONBOARDING_DATA,
});
